// @ts-check
const MODULE_ROUTE = '/production/productionPlanner';

export default [
  {
    path: MODULE_ROUTE,
    asyncComponent: () => import('@/pages/production/productionPlanner/FrmProductionPlannerHome.vue'),
  },
];
